import { isAdminEmail } from './selectors'

type FirebaseUserProviderData = {
  email?: string | null
}

type FirebaseUserLike = {
  email?: string | null
  displayName?: string | null
  providerData?: ReadonlyArray<FirebaseUserProviderData | null>
}

export const getFirebaseUserEmail = (
  user: Pick<FirebaseUserLike, 'email'> & {
    providerData?: ReadonlyArray<FirebaseUserProviderData | null>
  }
): string | null => {
  const directEmail = user.email?.trim()
  if (directEmail) return directEmail

  const providerEmail = user.providerData
    ?.map((provider) => provider?.email?.trim() ?? '')
    .find((email) => email !== '')

  return providerEmail ?? null
}

export const parseCustomerProfileId = (
  displayName: string | null | undefined
): number | undefined => {
  if (displayName == null || displayName === '') return undefined
  const profileId = Number(displayName)
  return Number.isNaN(profileId) ? undefined : profileId
}

export const isAdminFirebaseUser = (
  user: FirebaseUserLike,
  adminEmail: string
) => isAdminEmail(getFirebaseUserEmail(user), adminEmail)

export const getCustomerProfileIdForUser = (
  user: FirebaseUserLike,
  adminEmail: string
): number | undefined =>
  isAdminFirebaseUser(user, adminEmail)
    ? undefined
    : parseCustomerProfileId(user.displayName)

export const shouldFetchPortalData = (
  isAuthenticated: boolean,
  isAdmin: boolean
) => isAuthenticated && !isAdmin
